import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import feedbackModes from '../feedbackModes.json';
import styles from './styles.module.styl';

// Only enable feedback boolean buttons if there is no feedback selected
// or it has been selected the option of the same type
const isEnabled = (btnFeedbackMode, currentMode) =>
  currentMode === feedbackModes.NONE || currentMode === btnFeedbackMode;

const BooleanFeedbackButton = ({
  text,
  btnFeedbackMode,
  currentFeedbackMode,
  handleClick
}) => (
  <button
    className={cx(
      styles.btn,
      currentFeedbackMode === btnFeedbackMode && styles.active
    )}
    onClick={handleClick}
    disabled={!isEnabled(btnFeedbackMode, currentFeedbackMode)}
  >
    {text}
  </button>
);

BooleanFeedbackButton.propTypes = {
  text: PropTypes.string.isRequired,
  btnFeedbackMode: PropTypes.string.isRequired,
  currentFeedbackMode: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default BooleanFeedbackButton;
